import DefaultElementNodeType from '../DefaultElementNodeType';
import {IMP_MIG_IMPLEMENTATION_EVENT} from '../../metamodel/Concept';

export default class ImplementationEventNodeType extends DefaultElementNodeType {
	static get typeName() {
		return IMP_MIG_IMPLEMENTATION_EVENT;
	}
}
